/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResponseListLong,
  ResponseListRocketWarehouseResVo,
  ResponsePageDataRocketWarehouseResVo,
  ResponseRocketWarehouseResVo,
  RocketWarehouseAddReqVo,
  RocketWarehouseDelReqVo,
  RocketWarehouseUpdateReqVo,
} from '../models/index';
import {
    ResponseListLongFromJSON,
    ResponseListLongToJSON,
    ResponseListRocketWarehouseResVoFromJSON,
    ResponseListRocketWarehouseResVoToJSON,
    ResponsePageDataRocketWarehouseResVoFromJSON,
    ResponsePageDataRocketWarehouseResVoToJSON,
    ResponseRocketWarehouseResVoFromJSON,
    ResponseRocketWarehouseResVoToJSON,
    RocketWarehouseAddReqVoFromJSON,
    RocketWarehouseAddReqVoToJSON,
    RocketWarehouseDelReqVoFromJSON,
    RocketWarehouseDelReqVoToJSON,
    RocketWarehouseUpdateReqVoFromJSON,
    RocketWarehouseUpdateReqVoToJSON,
} from '../models/index';

export interface RocketWarehouseAllGetRequest {
    currentPage?: number;
    pageSize?: number;
    code?: string;
    name?: string;
    enable?: number;
}

export interface RocketWarehouseDeleteRequest {
    rocketWarehouseDelReqVo?: RocketWarehouseDelReqVo;
}

export interface RocketWarehouseGetRequest {
    currentPage?: number;
    pageSize?: number;
    code?: string;
    name?: string;
    enable?: number;
}

export interface RocketWarehouseIdGetRequest {
    id: number;
}

export interface RocketWarehouseIdPutRequest {
    id: number;
    rocketWarehouseUpdateReqVo?: RocketWarehouseUpdateReqVo;
}

export interface RocketWarehouseIdStatusPatchRequest {
    id: number;
    enable: number;
}

export interface RocketWarehousePostRequest {
    rocketWarehouseAddReqVo?: RocketWarehouseAddReqVo;
}

/**
 * 
 */
export class RocketWarehouseControllerApi extends runtime.BaseAPI {

    /**
     * 火箭仓库列表查询（不分页） 火箭仓库·列表查询（不分页）
     * 火箭仓库·列表查询（不分页）
     */
    async rocketWarehouseAllGetRaw(requestParameters: RocketWarehouseAllGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListRocketWarehouseResVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rocket-warehouse/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListRocketWarehouseResVoFromJSON(jsonValue));
    }

    /**
     * 火箭仓库列表查询（不分页） 火箭仓库·列表查询（不分页）
     * 火箭仓库·列表查询（不分页）
     */
    async rocketWarehouseAllGet(requestParameters: RocketWarehouseAllGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListRocketWarehouseResVo> {
        const response = await this.rocketWarehouseAllGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 批量删除火箭仓库 火箭仓库·批量删除
     * 火箭仓库·批量删除
     */
    async rocketWarehouseDeleteRaw(requestParameters: RocketWarehouseDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rocket-warehouse`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RocketWarehouseDelReqVoToJSON(requestParameters['rocketWarehouseDelReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListLongFromJSON(jsonValue));
    }

    /**
     * 批量删除火箭仓库 火箭仓库·批量删除
     * 火箭仓库·批量删除
     */
    async rocketWarehouseDelete(requestParameters: RocketWarehouseDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListLong> {
        const response = await this.rocketWarehouseDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 火箭仓库分页列表查询 火箭仓库·分页列表查询
     * 火箭仓库·分页列表查询
     */
    async rocketWarehouseGetRaw(requestParameters: RocketWarehouseGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataRocketWarehouseResVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rocket-warehouse`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataRocketWarehouseResVoFromJSON(jsonValue));
    }

    /**
     * 火箭仓库分页列表查询 火箭仓库·分页列表查询
     * 火箭仓库·分页列表查询
     */
    async rocketWarehouseGet(requestParameters: RocketWarehouseGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataRocketWarehouseResVo> {
        const response = await this.rocketWarehouseGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取火箭仓库详情 火箭仓库·详情查询
     * 火箭仓库·详情查询
     */
    async rocketWarehouseIdGetRaw(requestParameters: RocketWarehouseIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseRocketWarehouseResVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rocketWarehouseIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rocket-warehouse/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseRocketWarehouseResVoFromJSON(jsonValue));
    }

    /**
     * 获取火箭仓库详情 火箭仓库·详情查询
     * 火箭仓库·详情查询
     */
    async rocketWarehouseIdGet(requestParameters: RocketWarehouseIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseRocketWarehouseResVo> {
        const response = await this.rocketWarehouseIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 更新火箭仓库信息 火箭仓库·更新
     * 火箭仓库·更新
     */
    async rocketWarehouseIdPutRaw(requestParameters: RocketWarehouseIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseRocketWarehouseResVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rocketWarehouseIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rocket-warehouse/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RocketWarehouseUpdateReqVoToJSON(requestParameters['rocketWarehouseUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseRocketWarehouseResVoFromJSON(jsonValue));
    }

    /**
     * 更新火箭仓库信息 火箭仓库·更新
     * 火箭仓库·更新
     */
    async rocketWarehouseIdPut(requestParameters: RocketWarehouseIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseRocketWarehouseResVo> {
        const response = await this.rocketWarehouseIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 修改火箭仓库状态 火箭仓库·修改状态
     * 火箭仓库·修改状态
     */
    async rocketWarehouseIdStatusPatchRaw(requestParameters: RocketWarehouseIdStatusPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseRocketWarehouseResVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rocketWarehouseIdStatusPatch().'
            );
        }

        if (requestParameters['enable'] == null) {
            throw new runtime.RequiredError(
                'enable',
                'Required parameter "enable" was null or undefined when calling rocketWarehouseIdStatusPatch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rocket-warehouse/{id}/status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseRocketWarehouseResVoFromJSON(jsonValue));
    }

    /**
     * 修改火箭仓库状态 火箭仓库·修改状态
     * 火箭仓库·修改状态
     */
    async rocketWarehouseIdStatusPatch(requestParameters: RocketWarehouseIdStatusPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseRocketWarehouseResVo> {
        const response = await this.rocketWarehouseIdStatusPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 新增火箭仓库 火箭仓库·新增
     * 火箭仓库·新增
     */
    async rocketWarehousePostRaw(requestParameters: RocketWarehousePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseRocketWarehouseResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/rocket-warehouse`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RocketWarehouseAddReqVoToJSON(requestParameters['rocketWarehouseAddReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseRocketWarehouseResVoFromJSON(jsonValue));
    }

    /**
     * 新增火箭仓库 火箭仓库·新增
     * 火箭仓库·新增
     */
    async rocketWarehousePost(requestParameters: RocketWarehousePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseRocketWarehouseResVo> {
        const response = await this.rocketWarehousePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
